import { PurchaseReasonEnum } from '@cineamo/api/constants/PurchaseReason.enum';

// Bridges an ad click to a later ticket purchase-intent: the click handler stores this, and
// `ticket-purchase-intent-helper` (app-level, reads the same key) attaches it to the purchase
// intent so the funnel can attribute the sale back to the ad + variant.
type AdClickAttribution = {
    adClickUid: string;
    purchaseReason: PurchaseReasonEnum;
    clickedAt: number;
};

const sessionStorageKey = (contentId: number | string) => `adClick-${contentId}`;

export function storeAdClickAttribution(contentId: number | string, adClickUid: string): void {
    const attribution: AdClickAttribution = {
        adClickUid,
        purchaseReason: PurchaseReasonEnum.AD_CLICK_DIRECT,
        clickedAt: Date.now()
    };
    sessionStorage.setItem(sessionStorageKey(contentId), JSON.stringify(attribution));
}

// Called when the visitor navigates away without buying — reclassifies a previously stored click
// as "same session" so a purchase later in the session is still attributed to it.
export function markAdClickAttributionAsSameSession(contentId: number | string): void {
    const key = sessionStorageKey(contentId);
    const stored = sessionStorage.getItem(key);
    if (!stored) {
        return;
    }
    try {
        const { adClickUid, clickedAt }: AdClickAttribution = JSON.parse(stored);
        const attribution: AdClickAttribution = {
            adClickUid,
            purchaseReason: PurchaseReasonEnum.AD_CLICK_SAME_SESSION,
            clickedAt
        };
        sessionStorage.setItem(key, JSON.stringify(attribution));
    } catch {
        sessionStorage.removeItem(key);
    }
}
